import { AxiosInstance } from "axios"

export const getUsersByProcessingUnitId = async (api: AxiosInstance, processingUnitId): Promise<any> => {
  try {
    const res: any = await api.get("/api/admin/User/GetUsersByProcessingUnitId", {
      params: { processingUnitId },
    })
    return res?.data
  } catch (error) {}
}